export enum ButtonType {
  PRIMARY,
  SECONDARY,
  TERTIARY,
  ROUNDED,
  ALERT,
  LIGHTSMALL,
  DARKSMALL,
  PRIMARYSMALL,
  CANCEL,
  SAVE,
  EDIT,
  CANCELINLINE,
  DELETE,
  RESET
}

export default ButtonType;